/**
 * @generated SignedSource<<c00ed5da0a3fc846a431a9edabb0f10e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type FilterMeetingOwnership = "ALL_MEETINGS" | "CUSTOM" | "ORGANIZED_BY_ME";
export type UserMeetingRecapSendTo = "ALL" | "INTERNAL" | "JUST_ME" | "NONE";
export type aiPageQuery$variables = {};
export type aiPageQuery$data = {
  readonly account: {
    readonly allowPublicRecap: boolean;
    readonly allowUserAutoRecord: boolean;
    readonly billingAccount: {
      readonly hasAccessToDefaultUserConfigurations: boolean;
    };
    readonly defaultUserAutoRecordSettings: {
      readonly allowUsersToChangeAutoRecordSettings: boolean;
      readonly enabled: boolean;
      readonly meetingOwnershipFilter: FilterMeetingOwnership;
    };
    readonly defaultUserMeetingRecapAutoShareSettings: {
      readonly allowUsersToChangeAlwaysEmailWhenAttendee: boolean;
      readonly allowUsersToChangeSendTo: boolean;
      readonly alwaysEmailWhenAttendee: boolean;
      readonly sendTo: UserMeetingRecapSendTo;
    };
    readonly emailDomainList: ReadonlyArray<string>;
  };
};
export type aiPageQuery = {
  response: aiPageQuery$data;
  variables: aiPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "allowPublicRecap",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "allowUserAutoRecord",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "emailDomainList",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "enabled",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "meetingOwnershipFilter",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "allowUsersToChangeAutoRecordSettings",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sendTo",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "alwaysEmailWhenAttendee",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "allowUsersToChangeSendTo",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "allowUsersToChangeAlwaysEmailWhenAttendee",
  "storageKey": null
},
v10 = {
  "alias": "hasAccessToDefaultUserConfigurations",
  "args": [
    {
      "kind": "Literal",
      "name": "feature",
      "value": "default_user_configurations"
    }
  ],
  "kind": "ScalarField",
  "name": "hasAccessToFeature",
  "storageKey": "hasAccessToFeature(feature:\"default_user_configurations\")"
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "aiPageQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Account",
        "kind": "LinkedField",
        "name": "account",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountDefaultUserAutoRecordSettings",
            "kind": "LinkedField",
            "name": "defaultUserAutoRecordSettings",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountDefaultUserMeetingRecapAutoShareSettings",
            "kind": "LinkedField",
            "name": "defaultUserMeetingRecapAutoShareSettings",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "BillingAccount",
            "kind": "LinkedField",
            "name": "billingAccount",
            "plural": false,
            "selections": [
              (v10/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "aiPageQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Account",
        "kind": "LinkedField",
        "name": "account",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountDefaultUserAutoRecordSettings",
            "kind": "LinkedField",
            "name": "defaultUserAutoRecordSettings",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v11/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountDefaultUserMeetingRecapAutoShareSettings",
            "kind": "LinkedField",
            "name": "defaultUserMeetingRecapAutoShareSettings",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v11/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "BillingAccount",
            "kind": "LinkedField",
            "name": "billingAccount",
            "plural": false,
            "selections": [
              (v10/*: any*/),
              (v11/*: any*/)
            ],
            "storageKey": null
          },
          (v11/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ac43923d951b6508778c485aae2f1ab6",
    "id": null,
    "metadata": {},
    "name": "aiPageQuery",
    "operationKind": "query",
    "text": "query aiPageQuery {\n  account {\n    allowPublicRecap\n    allowUserAutoRecord\n    emailDomainList\n    defaultUserAutoRecordSettings {\n      enabled\n      meetingOwnershipFilter\n      allowUsersToChangeAutoRecordSettings\n      id\n    }\n    defaultUserMeetingRecapAutoShareSettings {\n      sendTo\n      alwaysEmailWhenAttendee\n      allowUsersToChangeSendTo\n      allowUsersToChangeAlwaysEmailWhenAttendee\n      id\n    }\n    billingAccount {\n      hasAccessToDefaultUserConfigurations: hasAccessToFeature(feature: default_user_configurations)\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "6639aa9daa1d1f1ec907b14c2fea0496";

export default node;
